export enum CarStatus {
  POSTING_TO_PROCESS = "POSTING_TO_PROCESS",
  POSTING_PROCESSED = "POSTING_PROCESSED",
  DRAFT = "DRAFT",
  LISTED = "LISTED",
  UNLISTED = "UNLISTED",
  CANCELLED = "CANCELLED"
}

export enum CarRefItemStatus {
  REVIEW = "REVIEW",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED"
}

export enum CarRefItemCode {
  MAN = "MANUFACTURER",
  MAK = "MAKE",
  MOD = "MODEL",
  VER = "VERSION",
  ENG = "ENGINE",
  FEA = "FEATURE",
  JTE = "JOB-TEMPLATE",
  JTA = "JOB-TASK"
}

export enum CarBodyType {
  CABRIOLET = "CABRIOLET", 
  SUV = "SUV", 
  PICKUP = "PICKUP"
}

export enum CarFuelType {
  DIESEL = "DIESEL",
  DIESEL_ELECTRIC = "DIESEL_ELECTRIC",
  PETROL = "PETROL",
  PETROL_ELECTRIC = "PETROL_ELECTRIC",
  ELECTRIC = "ELECTRIC",
  HYBRID = "HYBRID",
  OTHER = "OTHER"
}

export enum CarGearBox {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
  SEMIAUTO = "SEMIAUTO"
}

export enum CarDoors {
  TWO = 2,
  TRHEE= 3,
  FOUR = 4,
  FIVE = 5,
  PLUS = 6
}

/*
export enum ProposalStatus {
  PROPOSED = "PROPOSED",
  BUYER_RESC = "BUYER_RESC",
  SELLER_RESC = "SELLER_RESC",
  SCHEDULED = "SCHEDULED",
  CANCELLED = "CANCELLED"
}

export enum BookingStatus {
  RESERVED = "RESERVED",
  ACCEPTED = "ACCEPTED",
  PAID = "PAID",
  UNAVAILABLE = "UNAVAILABLE",
  CANCELLED = "CANCELLED"
}
*/
export enum CarBusinessLine {
  BUY = "BUY",
  RENT = "RENT",
  KEEP = "KEEP"
};

export enum CarWheelType {
  ALLOY = "ALLOY",
  STEEL = "STEEL"
};

export enum CarADASLevel {
  NO_0 = "0 - No autonomy",
  BASIC_1 = "1 - Basic",
  PARTIAL_2 = "2 - Partial",
  CONDITIONAL_3 = " 3 - Conditional",
  HIGH_4 = "4 - High",
  FULL_5 = "5 - Full"
};

export enum EngineInjectionType {
  SEQUENTIAL_FUEL_INJECTION = "SEQUENTIAL_FUEL_INJECTION",
  DIRECT_INJECTION = "DIRECT_INJECTION",
  SINGLE_POINT_INJECTION = "SINGLE_POINT_INJECTION",
  MULTI_POINT_INJECTION = "MULTI_POINT_INJECTION"
};


export enum CarFeatureBD {
  ELECTRONIC_PARKING_BRAKE = "ELECTRONIC_PARKING_BRAKE",
  CAMERA_360 = "CAMERA_360",
  CAMERA = "CAMERA",
  GPS = "GPS",
  DRIVER_MONITOR_SYSTEM = "",
  ROAD_SIGN_RECOGNITION = "",
  AUTOMATIC_EMERGENCY_BRAKING = "",
  AUTOMATIC_EMERGENCY_STEERING = "",
  AWD = "",
  AWD_4WD = "",

  AUTOMATIC_PARKING_ASSIST = "KEEP",
  NIGHT_VISION_ASSIST = "",
  ADAPTATIVE_CRUISE_CONTROL = "",
  STANDARD_CRUISE_CONTROL = "",
  DIGITAL_COCKPIT = "",
  HUD_HEADS_UP_DISPLAY = "",
  BLIND_SPOT_MONITOR = "",
  LANE_DEPARTURE_MONITOR  = "",
  FORWARD_COLLISION_MONITOR  = "",
  REAR_CROSS_TRAFFIC_MONITOR  = "",

  HILL_ASSIST = "",
  ESC_ELECTRONIC_STABILITY_CONTROL = "",
  TYRE_PRESSURE_MONITOR = "",
  ABS_EBD = "",
  ABS = "",
  AUTOMATIC_CLIMATE_CONTROL = "",
  DUAL_ZONE_CLIMATE_CONTROL = "",
  ANTI_PINCH_POWER_WINDOWS = "",
  HEATED_ORVM = "",
  HILL_DESCENT_CONTROL = "",
  APPLE_CAR_DISPLAY = "",
  ANDROID_AUTO = "",
  HANDS_FREE_TAILGATE = "",
  MILD_HYBRID = "",
  DRIVING_MODE = "",
  REAL_TIME_VEHICLE_TRACKING = "",
  ENGINE_IMMOBILIZER = "",
  LIMITED_SLIP_DIFFERENTIAL = "",
  STEERING_ADJUSTMENT_TYPE = "",
  MILEAGE_ARAI = "",
  TACHOMETER = "",
  HID_XENON_HEADLAMPS = "",
  BODY_KIT = "",
  REAR_SPOILER = "",
  SEAT_LUMBAR_SUPPORT = "",
  ADJUSTABLE_LUMBAR_SUPPORT = "",
  TAILGATE_AJAR_SENSOR = "",
  VOICE_COMMAND_CONTROL = "",
  ELECTRICAL_ADJUSTABLE_HEADRESTS = "",
  ACTIVE_NOISE_CANCELLATION = "",
  SMART_KEY_BAND = "",
  PADDLE_SHIFTERS = "",
  TRACTION_CONTROL = "",
  PRESAFE_SOUND = "",
  CHILD_SEAT_ANCHOR_POINTS_ISOFIX = "",
  FOLLOW_ME_HOME_HEADLAMPS = "",
  AIRBAGS = "",
  DUAL_STAGE_AIRBAGS = "",
  DIFFERENTIAL_LOCK = "",
  ENGINE_CHECK_WARNING = "",
  PRETENSIONERS_FORCE_LIMITERS_SEATBELTS = "",
  SOS_EMERGENCY_ASSISTANCE = "",
  EBD_CORNERNING_BRAKE_CONTROL = "",
  GEOFENCE_ALERT = "",
  KERB_WEIGHT = "",
  SUPERCHARGER = "",
  TURBOCHARGER = "",
  KEYLESS_ENTRY = "",
  SMART_ACCESS_CARD_ENTRY = ""
};

// export enum DocumentCategory {
//   REG_CERTIFICATE = "Carte grise",
//   DRIVING_LICENCE = "Permis de conduire",
//   INSURANCE_POLICY = "Devis assurance",
//   INSURANCE_QUOTE = "Police assurance"
// };

export class CarBasicData {

    private static makes = ["MERCEDES", "LEXUS", "TOYOTA"];
    private static models = ["GT 7", "A 12", "C6"];
    public static bodyTypes = [CarBodyType.CABRIOLET, CarBodyType.SUV, CarBodyType.PICKUP];
    
    public static gearboxes = [CarGearBox.MANUAL, CarGearBox.AUTO,CarGearBox.SEMIAUTO];
    public static fuelTypes = [CarFuelType.DIESEL, CarFuelType.ELECTRIC, CarFuelType.HYBRID, CarFuelType.PETROL, CarFuelType.OTHER];

    public static dealerTypes = ["PERSONAL", "PROFESSIONAL"];
    

    public static carStatuses: any = {
      DRAFT: {
        next: "LISTED",
        action: "Publier"
      },
      LISTED: {
        next: "UNLISTED",
        action: "Dépublier"
      },
      UNLISTED: {
        next: "LISTED",
        action: "Publier"
      },
      SOLD: {
        next: ""
      },
      CANCELLED: {
        next: ""
      }
    }

    private static mkmdv  = [
        {
            "id": 1,
            "make": "MERCEDES",
            "models": [
                "170", "180", "190", "200", "208", "210"
            ]
        },
        {
            "id": 2,
            "make": "TOYOTA",
            "models": [
                "4-Runner", "Allion", "Alphard", "Altezza", "Aristo", "Auris", "Avalon", "Avensis"
            ]
        },
        {
            "id": 3,
            "make": "VOLKSWAGEN",
            "models": [
                "181", "Amarok", "Anfibio", "Arteon", "Atlas", "Beetle"
            ]
        },

        {
            "id": 4,
            "make": "BMW",
            "models": [
                "i3", "i4", "i7", "i8", "iX", "iX1"
            ]
        },

    ];

    public static getMakesBD(): string[]{
        let mks: string[] = [];
        this.mkmd.forEach((c) => mks.push(c.make));
        return mks;
    }

    public static getModelsBD(mks: string[]): string[]{
        let mdls: string[] = [];
        this.mkmd.forEach((m) => {
          if(mks.includes(m.make)){
            mdls = [ ...mdls, ...m.models];
          }
        });
        return mdls;       
    }



    private static mkmd  = [
        {
          "id": 1,
          "make": "MERCEDES",
          "models": [
            "170",
            "180",
            "190",
            "200",
            "208",
            "210",
            "211",
            "ML350",
            "C320",
            "C300",
            "C400",
            "GLE350",
            "GLA350",
            "Classe S",
            "Classe M",
            "Classe G",
            "Classe E",
            "4Matic"
          ]
        },
        {
          "id": 2,
          "make": "TOYOTA",
          "models": [
            "4-Runner",
            "Allion",
            "Alphard",
            "Altezza",
            "Aristo",
            "Auris",
            "Avalon",
            "Avensis",
            "Avensis Verso",
            "Camry",
            "Corolla",
            "Fortuner",
            "Highlander",
            "Land Cruiser",
            "Urban Cruiser",
            "Verso",
            "Yaris",
            "RAV4"
          ]
        },
        {
          "id": 3,
          "make": "VOLKSWAGEN",
          "models": [
            "181",
            "Amarok",
            "Anfibio",
            "Arteon",
            "Atlas",
            "Beetle",
            "Polo",
            "Touareg",
            "Golf"
          ]
        },
        {
          "id": 4,
          "make": "BMW",
          "models": [
            "I3",
            "I4",
            "I7",
            "I8",
            "IX",
            "IX1",
            "IX3",
            "Serie 1",
            "Serie 2",
            "Serie 3 ",
            "Serie 4",
            "Serie 5",
            "Serie 6",
            "Serie 7",
            "Serie 8",
            "Serie M",
            "Serie X",
            "Serie Z"
          ]
        },
        {
          "id": 5,
          "make": "NISSAN",
          "models": [
            "Almera",
            "Altima",
            "Juke",
            "Murano",
            "Pathfinder",
            "Patrol",
            "Primera",
            "Qashqai",
            "Rogue",
            "X-trail"
          ]
        },
        {
          "id": 6,
          "make": "FORD",
          "models": [
            "Cougar",
            "Edge",
            "Escape",
            "Explorer",
            "Fiesta",
            "Focus",
            "Kuga",
            "Ranger",
            "Tourneo",
            "Transit"
          ]
        },
        {
          "id": 7,
          "make": "HYUNDAI",
          "models": [
            "Elantra",
            "i10",
            "i20",
            "i30",
            "i40",
            "i50",
            "IONIQ",
            "IX20",
            "IX35",
            "IX55",
            "Santa Fe",
            "Sonata",
            "Tucson"
          ]
        },
        {
          "id": 8,
          "make": "LEXUS",
          "models": [
            "ES model",
            "RS model",
            "GS model",
            "GX model",
            "IS model",
            "LS model",
            "LX model",
            "NX model",
            "RX model",
            "Beetle"
          ]
        },
        {
          "id": 9,
          "make": "KIA",
          "models": [
            "K5",
            "Optima",
            "Sorento",
            "Sportage",
            "Stonic"
          ]
        }
      ];

    
}


